import Page from "@/views/Page";

export default {
    resolve(path) {
        switch (path) {
            case '/':
            case '/menu':
            case '/kontakt':
                return Page;
            default:
                return Page;
        }
    }
}